import { render, staticRenderFns } from "./QHcheckboxGroup.vue?vue&type=template&id=3b23f12e&scoped=true"
import script from "./QHcheckboxGroup.vue?vue&type=script&lang=js"
export * from "./QHcheckboxGroup.vue?vue&type=script&lang=js"
import style0 from "./QHcheckboxGroup.vue?vue&type=style&index=0&id=3b23f12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23f12e",
  null
  
)

export default component.exports